<template>
  <div class="header">
    <div class="container">
      <ul class="header__nav">
        <li class="nav-item">
          <el-popover placement="top-start" width="90" trigger="hover" v-show="userInfo.tel">
            <div>
              <router-link class="link" to="/Account/OrderList">个人中心</router-link>
              <p class="link" @click="loginOut">退出登录</p>
            </div>
            <span slot="reference">{{ userInfo.tel }}</span>
          </el-popover>
          <router-link v-show="!userInfo.tel" to="/Login">登录</router-link>
        </li>
        <li class="nav-item">
          <a href="https://www.huishoubao.com/news/8600.html?pid=1001" target="_blank">帮助中心</a>
        </li>
        <li class="nav-item">
          <a href="https://www.huishoubao.com/news/8496.html?pid=1001" target="_blank">关于我们</a>
        </li>
        <li class="nav-item">
          <a href="https://www.huishoubao.com/news/6791.html?pid=1001" target="_blank">服务条款</a>
        </li>
        <li class="nav-item">
          <a href="https://www.huishoubao.com/news/8493.html?pid=1001" target="_blank">交易流程</a>
        </li>
        <li class="nav-item" @mouseover="showSetMap=true" @mouseout="showSetMap=false">
          <a href="https://www.huishoubao.com/sitemap.html" target="_blank">网站导航</a>
          <div class="site-map-wrap clearfix" v-show="showSetMap">
            <div class="site-links">
              <h2>主要业务</h2>
              <router-link class="link" to="/products/1">手机回收</router-link>
              <router-link class="link" to="/products/3">平板回收</router-link>
              <router-link class="link" to="/products/3">电脑回收</router-link>
              <a class="link" href="http://best.weadoc.com/index.html" target="_blank" rel="nofollow">手机维修</a>
              <a class="link" href="http://www.keleyoupin.com.cn" target="_blank">可乐优品</a>
            </div>
            <div class="site-links">
              <h2>企业服务</h2>
              <a class="link" href="https://www.huishoubao.com/news/8492.html" target="_blank">质检名词解释</a>
              <a class="link" href="https://www.huishoubao.com/news/8494.html" target="_blank">质检流程说明</a>
              <a class="link" href="https://www.huishoubao.com/news/8495.html" target="_blank">数据备份</a>
            </div>
            <div class="site-links">
              <h2>用户导航</h2>
              <a class="link" href="https://www.huishoubao.com/sitemap.html" target="_blank">用户导航</a>
              <a class="link" href="https://www.huishoubao.com/sitemap_index.html" target="_blank">网站地图</a>
              <a class="link" href="https://www.huishoubao.com/news/12" target="_blank">帮助中心</a>
              <a class="link" href="https://www.huishoubao.com/news/5" target="_blank">新闻中心</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Popover } from 'element-ui';

export default {
  components: {
    [Popover.name]: Popover
  },
  data () {
    return {
      showSetMap: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    loginOut () {
      this.$store.commit('user/loginOut');
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
@import 'config.css';
.header {
  background-color: #f8f9fb;
  &__nav {
    text-align: right;
  }
}
.nav-item {
  position: relative;
  display: inline-block;
  margin-left: 30px;
  line-height: 40px;
  > * {
    color: $global-gray-color;
    cursor: pointer;
  }
  &:hover {
    > * {
      color: $global-primary-color;
    }
  }
}
.link {
  display: block;
  line-height: 30px;
  cursor: pointer;
}

.site-map-wrap {
  z-index: 999;
  position: absolute;
  width: 370px;
  top: 100%;
  right: 0;
  padding: 10px;
  /*margin-top: 5px;*/
  background-color: #fff;
  transition: all .4s;
  box-shadow: 0 1px 20px 2px rgb(200, 200, 200);
  .link {
    color: #999;
    &:hover {
      color: #e7b000;
    }
  }
  h2 {
    font-size: 13px;
    font-weight: bold;
    color: #333;
  }
  .site-links {
    float: left;
    margin-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/components/header/header.vue